import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import CryptoJS from "crypto-js";
import TrendingUp from "@material-ui/icons/TrendingUp";
import TrendingDown from "@material-ui/icons/TrendingDown";
import Add from "@material-ui/icons/Add";

import CustomInput from "components/CustomInput/CustomInput.jsx";
import CardBody from "components/Card/CardBody.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import NavPills from "components/NavPills/NavPills.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import FormControl from "@material-ui/core/FormControl";
import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx";
import InputAdornment from "@material-ui/core/InputAdornment";
import CardFooter from "components/Card/CardFooter.jsx";
import Button from "components/CustomButtons/Button.jsx";
import TextField from "@material-ui/core/TextField";
import API from "@aws-amplify/api";

// core components
const uuidv4 = require("uuid/v4");
const styles = {
  cardTitle,
  pageSubcategoriesTitle: {
    color: "#3C4858",
    textDecoration: "none",
    textAlign: "center"
  },
  cardCategory: {
    margin: "0",
    color: "#999999"
  }
};
let apiName = process.env.REACT_APP_AMPLIFY_API;

class Campaigns extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      clientId: "",
      campaignName: "",
      campaignDescription: "",
      campaignNameState: "",
      campaignDescriptionState: "",
      errorMsg: "",
      startDate: "",
      endDate: ""
    };
  }
  saveCampaigns = async event => {
    event.preventDefault();
    let path = "/users";
    let custHeaders = {
      headers: {
        userId: JSON.parse(CryptoJS.AES.decrypt(localStorage.getItem('userId'),'secretpass').toString(CryptoJS.enc.Utf8))
      }
    };
    //Gets the user Id from the localstorage and fectches the user record from cmp-users
    API.get(apiName, path, custHeaders)
      .then(response => {
        this.setState({ clientId: response[0]["clientId"] });


    if (
      this.state.campaignName !== "" &&
      this.state.campaignDescription !== ""
    ) {


      let campaignData = {
      headers: {},
      body: {
          id: uuidv4(),
          userId: JSON.parse(CryptoJS.AES.decrypt(localStorage.getItem('userId'),'secretpass').toString(CryptoJS.enc.Utf8)),
          //query: JSON.parse(map),
          createdAt: new Date()
            .toJSON()
            .slice(0, 10)
            .replace(/-/g, "/"),
          modifiedAt: new Date()
            .toJSON()
            .slice(0, 10)
            .replace(/-/g, "/"),
          campaignName: this.state.campaignName,
          campaignDescription: this.state.campaignDescription,
          startDate: this.state.startDate,
          endDate: this.state.endDate,
          clientId: this.state.clientId
          
        }
        };
        API.post(apiName, "/campaigns", campaignData)
        .then(response => {
        })
        .catch(error => {
        });
      }
      })
      .catch(error => {
      });

  };
  handleChangeIndex = index => {
    //this.setState({ active: index });
  };
  redirectToActive = () => {};
  verifyLength(value, length) {
    if (value.length >= length) {
      return true;
    }
    return false;
  }

  handleChange(event, type) {
    this.setState({
      [event.target.id]: event.target.value
    });

    switch (type) {
      case "campName":
        if (this.verifyLength(event.target.value, 8)) {
          this.setState({ campaignNameState: "success" });
        } else {
          this.setState({ campaignNameState: "error" });
        }
        break;
      case "campDesc":
        if (this.verifyLength(event.target.value, 8)) {
          this.setState({ campaignDescriptionState: "success" });
        } else {
          this.setState({ campaignDescriptionState: "error" });
        }
        break;
      default:
    }
  }
  render() {
    const { classes } = this.props;
    return (
      <div>
        <CardBody className="cardBodyMargin">
          <GridContainer justify="center">
            <GridItem xs={12} sm={12} md={8}>
              <NavPills
                color="warning"
                alignCenter
                onSelect={index => {
                }}
                tabs={[
                  {
                    tabButton: "Active",
                    tabIcon: TrendingUp,
                    tabContent: (
                      <Card>
                        <CardHeader>
                          <h4 className={classes.cardTitle}>
                            Campaign Details
                          </h4>
                        </CardHeader>
                        <CardBody>ALL ACTIVE CAMPAIGNS</CardBody>
                      </Card>
                    )
                  },
                  {
                    tabButton: "Ended",
                    tabIcon: TrendingDown,
                    tabContent: (
                      <Card>
                        <CardHeader>
                          <h4 className={classes.cardTitle}>
                            Location of the product
                          </h4>
                          <p className={classes.cardCategory}>
                            More information here
                          </p>
                        </CardHeader>
                        <CardBody>ALL ENDED CAMPAIGNS</CardBody>
                      </Card>
                    )
                  },
                  {
                    tabButton: "New",
                    tabIcon: Add,
                    tabContent: (
                      <Card>
                        <CardHeader>
                          <h4 className={classes.cardTitle}>
                            Campaign Details
                          </h4>
                        </CardHeader>
                        <CardBody>
                          <CustomInput
                            success={this.state.campaignNameState === "success"}
                            error={this.state.campaignNameState === "error"}
                            labelText="Campaign Name *"
                            id="campaignName"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              onChange: event =>
                                this.handleChange(event, "campName"),
                              endAdornment: (
                                <InputAdornment
                                  position="start"
                                  className={classes.inputAdornment}
                                />
                              )
                            }}
                          />

                          <CustomInput
                            success={
                              this.state.campaignDescriptionState === "success"
                            }
                            error={
                              this.state.campaignDescriptionState === "error"
                            }
                            labelText="Campaign Description *"
                            id="campaignDescription"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              onChange: event =>
                                this.handleChange(event, "campDesc"),
                              endAdornment: (
                                <InputAdornment
                                  position="start"
                                  className={classes.inputAdornment}
                                />
                              )
                            }}
                          />
                          <FormControl fullWidth>
                            <TextField
                              id="startDate"
                              label="Pick a start date here"
                              type="date"
                              // defaultValue="2017-05-24"
                              className={classes.textField}
                              onChange={event =>
                                this.handleChange(event, "startDate")
                              }
                              InputLabelProps={{
                                shrink: true
                              }}
                            />
                            {/* <Datetime
                              timeFormat={false}
                              id="startDate"
                              inputProps={{
                                onChange: event =>
                                  this.handleChange(event, "startDate"),
                                placeholder: "Pick a start date here"
                              }}
                            /> */}
                          </FormControl>

                          <FormControl fullWidth>
                            {/* <Datetime
                              timeFormat={false}
                              id="endDate"
                              inputProps={{
                                onChange: event =>
                                  this.handleChange(event, "endDate"),
                                placeholder: "Pick a end date here"
                              }}
                            /> */}
                            <TextField
                              id="endDate"
                              label="Pick a end date here"
                              type="date"
                              // defaultValue="2017-05-24"
                              className={classes.textField}
                              onChange={event =>
                                this.handleChange(event, "endDate")
                              }
                              InputLabelProps={{
                                shrink: true
                              }}
                            />
                          </FormControl>
                        </CardBody>
                        <CardFooter className={classes.justifyContentCenter}>
                          <Button
                            color="secondary"
                            size="lg"
                            type="submit"
                            onClick={this.saveCampaigns}
                          >
                            Save
                          </Button>
                          <Button
                            color="secondary"
                            size="lg"
                            onClick={this.redirectToActive}
                            type="submit"
                          >
                            Cancel
                          </Button>
                        </CardFooter>
                      </Card>
                    )
                  }
                ]}
              />
            </GridItem>
          </GridContainer>
        </CardBody>
      </div>
    );
  }
}

export default withStyles(styles)(Campaigns);



// WEBPACK FOOTER //
// ./src/views/Campaigns/Campaigns.jsx